// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/service_principal/v1/service_principal.proto" (package "c1.api.service_principal.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ServicePrincipalService } from "./service_principal";
import type { ServicePrincipalServiceRevokeCredentialResponse } from "./service_principal";
import type { ServicePrincipalServiceRevokeCredentialRequest } from "./service_principal";
import type { ServicePrincipalServiceUpdateCredentialResponse } from "./service_principal";
import type { ServicePrincipalServiceUpdateCredentialRequest } from "./service_principal";
import type { ServicePrincipalServiceGetCredentialResponse } from "./service_principal";
import type { ServicePrincipalServiceGetCredentialRequest } from "./service_principal";
import type { ServicePrincipalServiceListCredentialsResponse } from "./service_principal";
import type { ServicePrincipalServiceListCredentialsRequest } from "./service_principal";
import type { ServicePrincipalServiceCreateCredentialResponse } from "./service_principal";
import type { ServicePrincipalServiceCreateCredentialRequest } from "./service_principal";
import type { ServicePrincipalServiceListResponse } from "./service_principal";
import type { ServicePrincipalServiceListRequest } from "./service_principal";
import type { ServicePrincipalServiceDeleteResponse } from "./service_principal";
import type { ServicePrincipalServiceDeleteRequest } from "./service_principal";
import type { ServicePrincipalServiceUpdateResponse } from "./service_principal";
import type { ServicePrincipalServiceUpdateRequest } from "./service_principal";
import type { ServicePrincipalServiceGetResponse } from "./service_principal";
import type { ServicePrincipalServiceGetRequest } from "./service_principal";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ServicePrincipalServiceCreateResponse } from "./service_principal";
import type { ServicePrincipalServiceCreateRequest } from "./service_principal";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * ServicePrincipalService provides CRUD operations for service principals
 * and their client credentials.
 *
 * @generated from protobuf service c1.api.service_principal.v1.ServicePrincipalService
 */
export interface IServicePrincipalServiceClient {
    /**
     * Create creates a new service principal.
     *
     * @generated from protobuf rpc: Create
     */
    create(input: ServicePrincipalServiceCreateRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceCreateRequest, ServicePrincipalServiceCreateResponse>;
    /**
     * Get returns a service principal by ID.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: ServicePrincipalServiceGetRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceGetRequest, ServicePrincipalServiceGetResponse>;
    /**
     * Update updates a service principal's display name.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: ServicePrincipalServiceUpdateRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceUpdateRequest, ServicePrincipalServiceUpdateResponse>;
    /**
     * Delete deletes a service principal and all its credentials.
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: ServicePrincipalServiceDeleteRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceDeleteRequest, ServicePrincipalServiceDeleteResponse>;
    /**
     * List lists service principals for the tenant.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ServicePrincipalServiceListRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceListRequest, ServicePrincipalServiceListResponse>;
    /**
     * CreateCredential creates a new client credential for a service principal.
     *
     * @generated from protobuf rpc: CreateCredential
     */
    createCredential(input: ServicePrincipalServiceCreateCredentialRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceCreateCredentialRequest, ServicePrincipalServiceCreateCredentialResponse>;
    /**
     * ListCredentials lists client credentials for a service principal.
     *
     * @generated from protobuf rpc: ListCredentials
     */
    listCredentials(input: ServicePrincipalServiceListCredentialsRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceListCredentialsRequest, ServicePrincipalServiceListCredentialsResponse>;
    /**
     * GetCredential returns a single client credential for a service principal.
     *
     * @generated from protobuf rpc: GetCredential
     */
    getCredential(input: ServicePrincipalServiceGetCredentialRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceGetCredentialRequest, ServicePrincipalServiceGetCredentialResponse>;
    /**
     * UpdateCredential updates a client credential for a service principal.
     *
     * @generated from protobuf rpc: UpdateCredential
     */
    updateCredential(input: ServicePrincipalServiceUpdateCredentialRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceUpdateCredentialRequest, ServicePrincipalServiceUpdateCredentialResponse>;
    /**
     * RevokeCredential revokes (deletes) a client credential for a service principal.
     *
     * @generated from protobuf rpc: RevokeCredential
     */
    revokeCredential(input: ServicePrincipalServiceRevokeCredentialRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceRevokeCredentialRequest, ServicePrincipalServiceRevokeCredentialResponse>;
}
/**
 * ServicePrincipalService provides CRUD operations for service principals
 * and their client credentials.
 *
 * @generated from protobuf service c1.api.service_principal.v1.ServicePrincipalService
 */
export class ServicePrincipalServiceClient implements IServicePrincipalServiceClient, ServiceInfo {
    typeName = ServicePrincipalService.typeName;
    methods = ServicePrincipalService.methods;
    options = ServicePrincipalService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Create creates a new service principal.
     *
     * @generated from protobuf rpc: Create
     */
    create(input: ServicePrincipalServiceCreateRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceCreateRequest, ServicePrincipalServiceCreateResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ServicePrincipalServiceCreateRequest, ServicePrincipalServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get returns a service principal by ID.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: ServicePrincipalServiceGetRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceGetRequest, ServicePrincipalServiceGetResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ServicePrincipalServiceGetRequest, ServicePrincipalServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update updates a service principal's display name.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: ServicePrincipalServiceUpdateRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceUpdateRequest, ServicePrincipalServiceUpdateResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ServicePrincipalServiceUpdateRequest, ServicePrincipalServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete deletes a service principal and all its credentials.
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: ServicePrincipalServiceDeleteRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceDeleteRequest, ServicePrincipalServiceDeleteResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ServicePrincipalServiceDeleteRequest, ServicePrincipalServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List lists service principals for the tenant.
     *
     * @generated from protobuf rpc: List
     */
    list(input: ServicePrincipalServiceListRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceListRequest, ServicePrincipalServiceListResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ServicePrincipalServiceListRequest, ServicePrincipalServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * CreateCredential creates a new client credential for a service principal.
     *
     * @generated from protobuf rpc: CreateCredential
     */
    createCredential(input: ServicePrincipalServiceCreateCredentialRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceCreateCredentialRequest, ServicePrincipalServiceCreateCredentialResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<ServicePrincipalServiceCreateCredentialRequest, ServicePrincipalServiceCreateCredentialResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListCredentials lists client credentials for a service principal.
     *
     * @generated from protobuf rpc: ListCredentials
     */
    listCredentials(input: ServicePrincipalServiceListCredentialsRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceListCredentialsRequest, ServicePrincipalServiceListCredentialsResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<ServicePrincipalServiceListCredentialsRequest, ServicePrincipalServiceListCredentialsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetCredential returns a single client credential for a service principal.
     *
     * @generated from protobuf rpc: GetCredential
     */
    getCredential(input: ServicePrincipalServiceGetCredentialRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceGetCredentialRequest, ServicePrincipalServiceGetCredentialResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<ServicePrincipalServiceGetCredentialRequest, ServicePrincipalServiceGetCredentialResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateCredential updates a client credential for a service principal.
     *
     * @generated from protobuf rpc: UpdateCredential
     */
    updateCredential(input: ServicePrincipalServiceUpdateCredentialRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceUpdateCredentialRequest, ServicePrincipalServiceUpdateCredentialResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<ServicePrincipalServiceUpdateCredentialRequest, ServicePrincipalServiceUpdateCredentialResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * RevokeCredential revokes (deletes) a client credential for a service principal.
     *
     * @generated from protobuf rpc: RevokeCredential
     */
    revokeCredential(input: ServicePrincipalServiceRevokeCredentialRequest, options?: RpcOptions): UnaryCall<ServicePrincipalServiceRevokeCredentialRequest, ServicePrincipalServiceRevokeCredentialResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<ServicePrincipalServiceRevokeCredentialRequest, ServicePrincipalServiceRevokeCredentialResponse>("unary", this._transport, method, opt, input);
    }
}
